$hover-btn-padding: calc(var(--covet-pics-item-label-font-size) + 10px);
$instagram-icon-width: calc(var(--covet-pics-item-label-font-size) + 5px);
$instagram-icon-height: calc(var(--covet-pics-item-label-font-size) + 5px);

// vars colors
$black:  #000000;
$white:  #FFFFFF;
@import "covet-pics-gallery-item-default";
@import "covet-pics-gallery-item-mixins";
@import "covet-pics-gallery-item-upload-widget";
@import "covet-pics-gallery-item-basic";
@import "covet-pics-gallery-item-warm";
@import "covet-pics-gallery-item-elegant";
@import "covet-pics-gallery-item-modern";
@import "covet-pics-gallery-item-bold";

